module.exports = __webpack_public_path__ + "img/KTP-169.4c6ec882.jpg";